import { ReactNode } from "react";
import { useIntersectionObserver } from "@/hooks/use-intersection-observer";

interface AnimatedSectionProps {
  children: ReactNode;
  animation?: "fade-in" | "slide-up" | "slide-left" | "slide-right" | "scale-in";
  delay?: number;
  className?: string;
}

export const AnimatedSection = ({ 
  children, 
  animation = "fade-in",
  delay = 0,
  className = ""
}: AnimatedSectionProps) => {
  const { elementRef, isVisible } = useIntersectionObserver({
    threshold: 0.1,
    rootMargin: "50px"
  });

  const animationClasses = {
    "fade-in": "opacity-0 translate-y-8",
    "slide-up": "opacity-0 translate-y-16",
    "slide-left": "opacity-0 translate-x-16",
    "slide-right": "opacity-0 -translate-x-16",
    "scale-in": "opacity-0 scale-95"
  };

  const visibleClasses = "opacity-100 translate-y-0 translate-x-0 scale-100";

  return (
    <div
      ref={elementRef}
      className={`
        transition-all duration-700 ease-out
        ${animationClasses[animation]}
        ${isVisible ? visibleClasses : ""}
        ${className}
      `}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
};
